import React from "react";
import Select from "react-select";
import { Query } from "@apollo/react-components";

let grades = [];

export default class Grades extends React.Component {
  render() {
    const customStyles = {
      control: (provided, state) => ({
        ...provided,
        backgroundColor: 'var(--input-bg)',
        borderColor: 'var(--border-color)',
        boxShadow: state.isFocused ? '0 0 0 1px var(--primary-color)' : 'none',
        '&:hover': {
          borderColor: 'var(--primary-color)'
        },
        minHeight: '38px',
        borderRadius: '8px',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        color: 'var(--text-color)',
        textAlign: 'left'
      }),
      menu: (provided) => ({
        ...provided,
        backgroundColor: 'var(--input-bg)',
        border: '1px solid var(--border-color)',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        zIndex: 9999,
        textAlign: 'left'
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused ? 'var(--primary-color)' : 'transparent',
        color: state.isFocused ? 'white' : 'var(--text-color)',
        cursor: 'pointer',
        padding: '8px 12px',
        textAlign: 'left',
        '&:hover': {
          backgroundColor: 'var(--primary-color)',
          color: 'white'
        }
      }),
      singleValue: (provided) => ({
        ...provided,
        color: 'var(--text-color)',
        textAlign: 'left'
      }),
      input: (provided) => ({
        ...provided,
        color: 'var(--text-color)',
        textAlign: 'left'
      }),
      placeholder: (provided) => ({
        ...provided,
        color: 'var(--text-muted)',
        textAlign: 'left'
      }),
      menuList: (provided) => ({
        ...provided,
        padding: '4px 0',
        maxHeight: '200px',
        textAlign: 'left'
      }),
      noOptionsMessage: (provided) => ({
        ...provided,
        color: 'var(--text-muted)',
        textAlign: 'left'
      }),
      loadingMessage: (provided) => ({
        ...provided,
        color: 'var(--text-muted)',
        textAlign: 'left'
      })
    };

    return (
      <Query query={this.props.service} fetchPolicy={"network-only"} variables={this.props.variables}>
        {({ loading, error, data }) => {
          if (loading) {
            return <div style={{ color: 'var(--text-color)' }}>Cargando...</div>;
          }
          if (error) {
            return <div style={{ color: 'var(--text-color)' }}>Error: {error.message}</div>;
          }
          if (data) {
            grades = [];
            for (const index in data[this.props.index]) {
              grades.push({
                label: data[this.props.index][index].description,
                value: data[this.props.index][index]
              });
            }
            return (
              <>
                <label className="form-label-custom" style={{
                  color: 'var(--text-color)',
                  fontSize: '0.9rem',
                  fontWeight: '500',
                  marginBottom: '0.5rem',
                  display: 'block',
                  textAlign: 'left'
                }}>Grado</label>
                <Select
                  value={this.props.grade}
                  onChange={e => this.props.handleChange(e, 'grade')}
                  options={grades}
                  styles={customStyles}
                  placeholder="Seleccione un grado"
                  noOptionsMessage={() => "No hay opciones disponibles"}
                  isClearable={false}
                  isSearchable={false}
                />
              </>
            );
          }
          return null;
        }}
      </Query>
    );
  }
}
